import { VaultSidebarInfoHeader } from 'src/components/Vaults/VaultSidebarInfoHeader';
import { VaultDetailsDrawerContent } from 'src/components/Vaults/VaultMainContent/VaultDetailsDrawerContent';
import { SubscribedVaultProvider } from 'src/providers/vaults/SubscribedVaultProvider';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import Button from 'src/components/primitives/Button/Button';
import { Open } from '@velocity-exchange/icons';

import SideDrawer from '../BaseDrawers/SideDrawer/SideDrawer';
import usePostHogCapture from 'src/hooks/posthog/usePostHogCapture';

export const VaultDetailsDrawer = () => {
	const handleCloseVaultDetailsDrawer = useDrawersStore(
		(s) => s.handleCloseDrawer
	);
	const { vault } = useDrawersStore((s) => s.vaultDetails);

	const { captureEvent } = usePostHogCapture();

	const onClose = () => {
		handleCloseVaultDetailsDrawer('vaultDetails');
	};

	if (!vault) {
		return null;
	}

	return (
		<SideDrawer.Container drawerName="vaultDetails">
			<SubscribedVaultProvider vaultPubkey={vault?.vaultPubkeyString ?? ''}>
				<SideDrawer.Title>
					<VaultSidebarInfoHeader uiVaultConfig={vault} />
				</SideDrawer.Title>
				<SideDrawer.Body>
					<VaultDetailsDrawerContent uiVaultConfig={vault} onClose={onClose} />
				</SideDrawer.Body>
				<SideDrawer.Footer className="w-full">
					<Button
						size="lg"
						className="w-full"
						as="a"
						href={
							vault.externalUiLink
								? vault.externalUiLink
								: `/vaults/strategy-vaults/${vault.vaultPubkeyString}`
						}
						onClick={() => {
							if (!vault.externalUiLink) {
								onClose();
							}

							captureEvent('vault_detail_opened');
						}}
						rightIcon={vault.externalUiLink ? Open : undefined}
						openInNewTab={!!vault.externalUiLink}
					>
						View Details
					</Button>

					{!vault.externalUiLink && (
						<Button
							size="lg"
							variant="secondary"
							className="w-full"
							as="a"
							href={`/?authority=${vault.vaultPubkeyString}`}
							onClick={() => captureEvent('vault_inspected')}
							rightIcon={Open}
							openInNewTab
						>
							Inspect Vault
						</Button>
					)}
				</SideDrawer.Footer>
			</SubscribedVaultProvider>
		</SideDrawer.Container>
	);
};
